<template>
  <div>
    <vue-ueditor-wrap v-model="editorContent" :config="config" @ready="ready" @beforeInit="addCustomButtom"></vue-ueditor-wrap>
    <input type="file" :id="upfileId" title="上传图片" accept="image/*" multiple :class="css.btn_upload" @change="uploadImg" />
    <k-popup :show.sync="showUpload" @after-ok="ok" title="上传图片">
      <div style="height: 430px; width: 700px; overflow: hidden; overflow-y: scroll; position: relative;">
        <div :class="css.img_box">
          <label :for="upfileId" v-if="imgUrl.length === 0" title="选择图片" :class="css.label">
            <k-icon name="k-icon-add" size="80" color="#666"></k-icon>
          </label>
          <template v-else>
            <div :class="css.img_wrapper" v-for="(item, index) in imgUrl" :key="index">
              <k-icon name="k-icon-close-circle" v-if="imgUrl && imgUrl.length > 0" @click="deleteImg(index)" :class="css.btn_delete"></k-icon>
              <img :src="item" :class="css.img" />
            </div>
          </template>
        </div>
      </div>
    </k-popup>
  </div>
</template>

<script>
// import "../../../../lib/ueditor/lang/zh-cn/zh-cn.js";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  props: {
    ueConfig: {
      type: Object,
      default: () => {},
    },
    content: {
      type: String,
    },
  },
  model: {
    prop: "content",
    event: "change",
  },
  watch: {
    showUpload(v) {
      if (!v) {
        this.imgUrl = [];
      }
    },
    editorContent(v) {
      this.$emit("change", v);
    },
    content(v) {
      if (v) {
        this.editorContent = v;
      } else {
        this.editorContent = "";
      }
    },
  },
  data() {
    return {
      upfileId: `upload${Math.random().toString(36).substr(2)}`,
      showUpload: false,
      imgUrl: [],
      editorContent: "",
      editor: null,
      dftConfig: {
        autoHeightEnabled: false,
        initialFrameHeight: 300,
        // 初始容器宽度
        initialFrameWidth: "100%",
        UEDITOR_HOME_URL: "lib/ueditor/",
        zIndex: 900,
        toolbars: [
          [
            "fullscreen",
            "source",
            "undo",
            "redo",
            "|",
            "bold",
            "italic",
            "underline",
            "fontborder",
            "strikethrough",
            "superscript",
            "subscript",
            "fontfamily",
            "fontsize",
            "forecolor",
            "backcolor",
            "insertorderedlist",
            "insertunorderedlist",
            "emotion",
            "|",
            "link",
          ],
        ],
      },
    };
  },
  components: {
    VueUeditorWrap,
  },
  computed: {
    config() {
      return Object.assign(this.dftConfig, this.ueConfig);
    },
  },
  methods: {
    ready(ue) {
      this.editor = ue;
      this.$emit("ready", ue);
    },
    addCustomButtom(editorId) {
      let _this = this;
      window.UE.registerUI(
        "upload-button",
        (editor, uiName) => {
          // 创建一个 button
          let btn = new window.UE.ui.Button({
            // 按钮的名字
            name: uiName,
            // 提示
            title: "上传图片",
            // 需要添加的额外样式，可指定 icon 图标，图标路径参考常见问题 2
            cssRules: "background-position: -380px 0;",
            // 点击时执行的命令
            onclick: function () {
              // 这里可以不用执行命令，做你自己的操作也可
              // editor.execCommand(uiName)
              _this.showUpload = true;
            },
          });

          // 当点到编辑内容上时，按钮要做的状态反射
          editor.addListener("selectionchange", () => {
            let state = editor.queryCommandState(uiName);
            if (state === -1) {
              btn.setDisabled(true);
              btn.setChecked(false);
            } else {
              btn.setDisabled(false);
              btn.setChecked(state);
            }
          });

          // 因为你是添加 button，所以需要返回这个 button
          return btn;
        },
        19 /* 指定添加到工具栏上的哪个位置，默认时追加到最后 */,
        editorId /* 指定这个 UI 是哪个编辑器实例上的，默认是页面上所有的编辑器都会添加这个按钮 */
      );
    },
    deleteImg(index) {
      //删除上传图片
      this.imgUrl.splice(index, 1);
    },
    uploadImg(e) {
      this.checkLoading(true);
      let file = e.target.files;
      let formData = new FormData();
      if (file && file.length > 0) {
        for (let i = 0; i < file.length; i++) {
          formData.append("file", file[i], file[i].name);
        }
      }
      formData.append("action", "_sku");
      this.$fetch({
        api: "/nestle-file-upload-server/upload/oss",
        para: formData,
        type: "multipart/form-data",
      })
        .then((data) => {
          this.checkLoading(false);
          let imgUrl = [];
          if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              imgUrl.push(data[i].url);
            }
          }
          this.imgUrl = imgUrl;
          this.$el.querySelector(`#${this.upfileId}`).value = "";
        })
        .catch((err) => {
          this.checkLoading(false);
          this.$el.querySelector(`#${this.upfileId}`).value = "";
        });
    },
    checkLoading(flag) {
      if (typeof this.$parent.loading != "undefined") {
        this.$parent.loading = flag;
      } else {
      }
    },
    ok() {
      if (!this.imgUrl || this.imgUrl.length === 0) {
        return this.$tips({ content: "请先上传图片", type: "error" }).hide(3000);
      }
      for (let i = 0; i < this.imgUrl.length; i++) {
        this.editor.execCommand("inserthtml", `<img src="${this.imgUrl[i]}" style="max-width:100%" />`);
      }
      this.showUpload = false;
    },
  },
};
</script>

<style lang="postcss" module="css">
.btn_upload {
  position: absolute;
  left: -9999px;
  top: 0;
  z-index: -1;
  opacity: 0;
}
.img_wrapper {
  position: relative;
  width: 650px;
  text-align: center;
}

.img_box {
  margin: 15px;
  min-height: 400px;

  overflow: auto;
  border: dashed 1px var(--color-border);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & .label {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    cursor: pointer;
    text-align: center;
    line-height: 400px;
    transition: all 0.3s;
    &:hover :global(.iconfont) {
      color: var(--color-link) !important;
      transition: all 0.3s;
    }
  }
  & img {
    max-width: 100%;
    max-height: 390px;
  }
}
.btn_delete {
  position: absolute;
  right: 25px;
  top: 25px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--color-font-2);
  color: #fff;
  text-align: center;
  line-height: 24px;
  cursor: pointer;
  z-index: 3;
  &:hover {
    background: var(--color-link);
  }
}
</style>
